import { useQuery } from "@apollo/client";
import { GET_CAMPAIGN_UPDATE } from "queries/hooks";
const useGetCampaignUpdate = ({ id }) => {
    var _a, _b;
    const { loading, error, data, refetch, } = useQuery(GET_CAMPAIGN_UPDATE, {
        variables: { id },
        skip: !id,
        onError: (err) => {
            console.error(err);
        },
    });
    const node = (_a = data === null || data === void 0 ? void 0 : data.campaignUpdate) !== null && _a !== void 0 ? _a : null;
    const update = node
        ? { ...node, reactions: (_b = node.reactions) !== null && _b !== void 0 ? _b : [] }
        : null;
    return {
        update,
        loading,
        error,
        refetch,
    };
};
export default useGetCampaignUpdate;
